// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"0aa42b08","453":"052382d8","460":"eb990b5d","773":"0c10e45b","893":"46fc792d"}[chunkId] + ".chunk.js";
};